import styled from 'styled-components'

const StyledTextDescriptorContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  .ant-input {
    width: auto;
  }
`

export default StyledTextDescriptorContainer
